import { createAsyncThunk } from "@reduxjs/toolkit";
import newsService from "../../../api/services/news";

// Postojeći thunks
export const getNews = createAsyncThunk(
  "news/get-news",
  async ({ page, search, includeInactive }) => {
    return await newsService.getNews({ page, search, includeInactive });
  }
);

export const getFeaturedNews = createAsyncThunk(
  "news/get-featured-news",
  async () => {
    return await newsService.getFeaturedNews();
  }
);

export const getNewsById = createAsyncThunk(
  "news/get-news-by-id",
  async (id) => {
    return await newsService.getNewsById(id);
  }
);

export const createNews = createAsyncThunk(
  "news/create-news",
  async (requestData) => {
    return await newsService.createNews(requestData);
  }
);

export const deleteNews = createAsyncThunk("news/delete-news", async (id) => {
  return await newsService.deleteNews(id);
});

export const toggleNewsStatus = createAsyncThunk(
  "news/toggle-news-status",
  async (id) => {
    return await newsService.toggleNewsStatus(id);
  }
);

export const editNews = createAsyncThunk(
  "news/edit-news",
  async ({ id, requestData }) => {
    return await newsService.editNews({ id, requestData });
  }
);

// NOVI THUNKS ZA DETAILS
export const getNewsDetails = createAsyncThunk(
  "news/get-news-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await newsService.getNewsDetails(id);
      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in getNewsDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateNewsDetails = createAsyncThunk(
  "news/update-news-details",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await newsService.updateNewsDetails({ id, data });
      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in updateNewsDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createNewsDetails = createAsyncThunk(
  "news/create-news-details",
  async (data, { rejectWithValue }) => {
    try {
      const response = await newsService.createNewsDetails(data);
      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in createNewsDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Za javni prikaz
export const getNewsPublicDetails = createAsyncThunk(
  "news/get-news-public-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await newsService.getNewsPublicDetails(id);
      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in getNewsPublicDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
